import _ from "lodash";

class ProviderQueue
{
	static processing = false;
	static processes = [];

	static addProcess (process)
	{
		this.processes.push(process);

		this.processQueue();
	}

	static async processQueue ()
	{
		if (this.processing || this.processes.length === 0)
		{
			return;
		}

		this.processing = true;

		for (const process of this.processes)
		{
			const result = await process.execute();

			process.onFinish({
				result
			});

			this.processes = _.filter(this.processes, p => p !== process);
		}

		this.processing = false;

		this.processQueue();
	}
}

export default ProviderQueue;
